export const keycloakMixin = {
  methods: {
    async logout() {
      console.debug('[keycloakMixin.logout] triggered...')
      try {
        // trigger logout from kuzzle with KC strategy & cleanup local stores
        await this.$store.dispatch('auth/GLOBAL_LOG_OUT', {
          kuzzle: this.$kuzzle,
          keycloak: this.$keycloak,
          // avoid infinite loop: only redirect to logout if keycloak is really authenticated,
          // otherwise redirect straight to login page
          showLogoutPrompt: this.$keycloak.authenticated,
        })
      } catch (logoutError) {
        this.$log.error(
          `[keycloakMixin.logout][error] failure trying to logout & redirect to keycloak login page.`,
        )
        this.$log.error(logoutError)
      }
    },
    /**
     * @function refreshToken
     * @description Try to refresh the Keycloak token. If fails, trigger logout.
     * @returns {Promise<boolean>} true if token refreshed, false if fails & logout triggered
     */
    async refreshToken() {
      this.$log.debug('[keycloakMixin.refreshToken] triggered...')
      try {
        // TODO: handle minValidity period to refresh token when inside a short window of remaining lifespan
        // https://stackoverflow.com/a/74206583/801307
        // trigger logout from kuzzle with KC strategy & cleanup local stores
        const tokenRefreshed = await this.$keycloak.updateToken()

        console.debug('[keycloakMixin.refreshToken] result:', tokenRefreshed)

        if (tokenRefreshed) {
          return true
        }

        this.$log.error(
          '[keycloakMixin.refreshToken] failure refreshing token, triggering logout ...',
        )
        await this.logout()
      } catch (tokenRefreshError) {
        this.$log.error(
          `[keycloakMixin.refreshToken][error] failure trying to refresh token in keycloak. triggering logout.`,
        )
        this.$log.error(tokenRefreshError)

        await this.logout()
      }
    },
    async updatePassword() {
      try {
        const passwordUpdated = await this.$store.dispatch(
          'auth/KEYCLOAK_LOGIN',
          {
            kuzzle: this.$kuzzle,
            keycloak: this.$keycloak,
            redirectUri: new URL(window.location.href),
            updatePassword: true,
          },
        )

        this.$log.debug(
          `[keycloakMixin.updatePassword] password update request success: '${passwordUpdated}'.`,
        )
      } catch (updatePasswordError) {
        this.$log.error(
          '[keycloakMixin.updatePassword][error] unable to update password in KC.',
        )
        this.$log.error(updatePasswordError)
      }
    },
  },
}
